export default __webpack_public_path__ + "resources/icons/d111-1880.png";